/** Dedicated entry permission: do not infer Miniapp access from ordinary inventory or fulfillment rights. */
export const MINIAPP_WAREHOUSE_ACCESS_PERMISSION = 'miniapp.warehouse.access';

export const MINIAPP_STOCK_LOOKUP_PERMISSION = 'inventory.stock_lookup.view';
